import { Button, Result } from 'antd';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { NonAdminLayout } from '../../components';

const Forbidden = () => {
  const history = useHistory();
  const location = useLocation();
  const [currentLocation, setCurrentLocation] = useState<string>('/users');

  useEffect(() => {
    const { from } = (location.state as any) || {
      from: { pathname: '/users' },
    };

    setCurrentLocation(from);
  }, [location]);

  const backToPrevious = () => history.replace(currentLocation);

  return (
    <NonAdminLayout>
      <Result
        status="403"
        title="403"
        subTitle={<FormattedMessage id="UserGroup.message.authorizedAccess" />}
        extra={
          <Button
            type="primary"
            onClick={backToPrevious}
            data-testid="forbidden-goback"
          >
            <FormattedMessage id="Global.goBack" />
          </Button>
        }
      />
    </NonAdminLayout>
  );
};

export default Forbidden;
